// This is a hack. The webChatEnabled value will be substituted at deploy time.
// If we try to evaluate webChatEnabled === "true" directly in the environment object
// it will always be false at build time.
const webchatEnabled =
  process.env.REACT_APP_WEBCHAT_ENABLED || "#{webchatEnabled}";

const environment = {
  CLIENT_NAME: process.env.REACT_APP_CLIENT_NAME ?? "#{clientName}",
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID ?? "#{userPoolId}",
  USER_POOL_CLIENT_ID:
    process.env.REACT_APP_USER_POOL_CLIENT_ID ?? "#{userPoolClientId}",
  CUSTOMER_PORTAL_API:
    process.env.REACT_APP_CUSTOMER_PORTAL_API ?? "#{customerPortalApi}",
  CUSTOMER_PORTAL_API_KEY:
    process.env.REACT_APP_CUSTOMER_PORTAL_API_KEY ?? "#{customerPortalApiKey}",
  MAINTENANCE_MODE:
    process.env.REACT_APP_MAINTENANCE_MODE ?? "#{maintenanceMode}",
  WEBCHAT_ENABLED: webchatEnabled === "true",
  CONNECT_SCRIPT_URL:
    process.env.REACT_APP_CONNECT_SCRIPT_URL ?? "#{connectScriptUrl}",
  CONNECT_SNIPPET_ID:
    process.env.REACT_APP_CONNECT_SNIPPET_ID ?? "#{connectSnippetId}",
  CONNECT_WIDGET_ID:
    process.env.REACT_APP_CONNECT_WIDGET_ID ?? "#{connectWidgetId}",
  PORTAL_LOGIN_URL:
    process.env.REACT_APP_PORTAL_LOGIN_URL ?? "#{portalLoginUrl}",
};
export default environment;
